import {UseCase} from '@s-ui/domain'

/**
 * @class
 * @implements UseCase
 */
export default class GetAuthenticationTokenUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} param
   * @param {GetAuthenticationTokenService} param.service
   */
  constructor({service}) {
    super({service})
    this._service = service
  }

  /**
   * @return {Promise<String>} authentication token
   */
  execute() {
    return this._service.execute()
  }
}
